module.exports = __webpack_public_path__ + "static/Cheltenhamcen-c941a18294e6186663d78599e8fa78df.jpg";